import { EndPoints } from "../../../Constants/endpoints";
import { useGetData } from "../../../hooks";
import { ManagementContactType } from "../../../interface/GeneralResponse";
import "react-quill/dist/quill.snow.css";

function TermsAndConditions() {
  const { data } = useGetData<ManagementContactType>(
    EndPoints.GetManagementContact,
  );

  const getContent = () => {
    return data?.Data?.TermsAndConditions || data?.Data?.TermsAndConditionsEn || "";
  };

  return (
    <div className="ql-snow">
      <div className="ql-editor">
        <div dangerouslySetInnerHTML={{ __html: getContent() }} />
      </div>
    </div>
  );
}

export default TermsAndConditions;
